import React from 'react'
// import { Navigate, NavLink, Outlet } from 'react-router-dom'
import './Css/footer.css'
// import { Outlet } from 'react-router-dom'

export default function Footer() {
  return (
    <>
      <div className="footer-container">
        {/* <div>logo</div> */}
        <div className="flex-container">
          <div className="details">
            <div className="heading homepage">Bharath Engineering Services</div>
            <div className="address">
              Office No.: 24-89/2/2A, West Anandbagh, Near Railway Track, Malkajgiri, 
              Medchal-Malkajgiri – 500047
            </div>
            <div className="cellphone">Contacts us: +91-9492194034</div>
            <div className="email">bharathengineeringservices143@gmail.com</div>
          </div>
          {/* <div className="products">
            <div className="heading products-head">Products</div>
            <div className="product-items">Pallet Trucks</div>
            <div className="product-items">Stackers</div>
            <div className="product-items">Trolley</div>
            <div className="product-items">Cranes</div>
            {/* <div className="product-items">Stackers</div> */}
          {/* </div> */} 
        </div>
        <div className="copyright">Copyright &#169; 2025</div>
      </div>
      {/* <Outlet /> */}
    </>
  );
}
